export default async function fetch_retry(url, options, n) {
  try {
    return await fetch(url, options).then((res) => {
      if (!res.ok) {
        throw new Error("Error en la petición");
      }
      return res;
    });
  } catch (err) {
    if (n <= 1) throw err;
    return await fetch_retry(url, options, n - 1);
  }
}
